export class LopHoc {
    id : number; 
    classCode : string
    className : string
    schoolId: number
    schoolLevelId: number

}